import React, { useState, useEffect } from 'react';
import { ItemList } from './ItemList';
import { VMVotingButtons } from "./vmVoting";
import { sendRequest } from "./vmUtils";
import { lambdaURL } from "../config";

export const VMPublicProfile = ({ displayUser, assemblyId }) => {
  const [votes, setVotes] = useState([]);
  const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      
      // Fetch topics for the assembly
      const topicsResponse = await sendRequest(lambdaURL, {
        command: "getTopicsForAssembly",
        assemblyId: assemblyId
      });

      if (topicsResponse.body) {
        const parsedTopics = JSON.parse(topicsResponse.body);
        setTopics(parsedTopics);
      }

      // Fetch displayUser's votes
      const votesResponse = await sendRequest(lambdaURL, {
        command: "getUserVotes",
        userId: displayUser?.PK?.replace('USER#', ''),
        assemblyId: assemblyId,
        topicId: selectedTopic || undefined
      });

      if (votesResponse.body) {
        console.log("Got votes:", votesResponse.body);
        const parsedVotes = JSON.parse(votesResponse.body);
        // Sort by date, most recent first
        if (parsedVotes != undefined && parsedVotes.length > 0) {
          const sortedVotes = parsedVotes.sort((a, b) => 
            new Date(b.createdAt) - new Date(a.createdAt)
          );
          setVotes(sortedVotes);
        }
      }

      setIsLoading(false);
    };

    fetchData();
  }, [displayUser, assemblyId, selectedTopic]);

  const renderVoteItem = (vote) => {

    console.log("Rendering vote item:", {
      proposalTitle: vote.proposalTitle,
      value: vote.value,
      rawVote: vote
    });

    return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex justify-between items-center">
        <div>
          <div className="font-semibold">{vote.proposalTitle}</div>
          <div className="text-sm text-gray-600">
            {new Date(vote.createdAt).toLocaleDateString()} -
            {vote.topicName && ` ${vote.topicName}`}
          </div>
        </div>
        <VMVotingButtons
          currentVote={vote.value}
          onVote={() => {}} // Read-only, no vote handler needed
          size="small"
          disabled={true}
        />
      </div>
      {vote.proposalDescription && (
        <div className="text-sm text-gray-700">
          {vote.proposalDescription}
        </div>
      )}
    </div>
    );
  };

  if (isLoading) {
    return <div className="vm-loading">Loading user profile...</div>;
  }

  return (
    <div className="vm-section">
      <div className="vm-section-title">
        <h2>Voting History for:</h2>
        <b style={{ fontSize: '16px'}}>{displayUser?.PK?.replace('USER#', '')}</b>
      </div>

      <div className="vm-form-vertical">
        <div className="vm-form-row">
          <select
            className="vm-form-input"
            value={selectedTopic}
            onChange={(e) => setSelectedTopic(e.target.value)}
          >
            <option value="">All Topics</option>
            {topics.map(topic => (
              <option 
                key={topic.SK.replace('TOPIC#', '')}
                value={topic.SK.replace('TOPIC#', '')}
              >
                {topic.name}
              </option>
            ))}
          </select>
        </div>

        <ItemList
          items={votes}
          onItemClick={() => {}}
          emptyMessage="No votes found"
          renderItem={renderVoteItem}
        />
      </div>
    </div>
  );
};
